export interface Faq {
  q: string
  a: string
}

export const faqs: Faq[] = [
  {
    q: 'Is Fitness Senior Ready™ a physical product?',
    a: 'No. It is a 100% digital system available immediately after purchase. Use it from your computer, tablet, or smartphone.',
  },
  {
    q: 'Who is this designed for?',
    a: 'Senior fitness coaches, personal trainers, group fitness instructors, active-aging professionals, and other qualified fitness professionals who work with older adults.',
  },
  {
    q: 'Are the classes ready to use?',
    a: 'Yes. The system includes complete session structures you can select and adapt according to your participants, environment, and professional judgment.',
  },
  {
    q: 'Can I use it with different ability levels?',
    a: 'Yes. Progressions, regressions, and adaptation options help you adjust the material to different participant capabilities.',
  },
  {
    q: 'Do I get lifetime access?',
    a: 'Yes. Your purchase includes lifetime access to the digital resources included with your order.',
  },
  {
    q: 'Are the bonuses included?',
    a: 'Yes. All five premium bonuses are included with the current offer at no additional cost.',
  },
  {
    q: 'Do I need years of experience with older adults to use this?',
    a: 'No. The Foundations module establishes the structure and safety considerations, so the system works whether you are moving into senior fitness or you have been teaching active-aging classes for years and simply want your planning organized.',
  },
  {
    q: 'Does this work for group classes as well as one-on-one training?',
    a: 'Yes. The sessions and progressions are built for group settings with mixed abilities, and the same material can be scaled down for individual personal training clients.',
  },
  {
    q: 'Can I print the sessions, planners, and checklists?',
    a: 'Yes. The session plans, trackers, assessments, and coaching resources are designed to be printed and used in the room, and many coaches keep them in a binder.',
  },
  {
    q: 'How quickly can I use it with my next class?',
    a: 'Immediately. You get instant access after purchase, and the Ready-To-Use Session Vault means you can select and teach a complete structured session the same day.',
  },
]
